// extracted by mini-css-extract-plugin
module.exports = {"st0":"minimap-module--st0--IyK_i","st1":"minimap-module--st1--3AegK","st2":"minimap-module--st2--ws4oe","st3":"minimap-module--st3--1NH_G","st6":"minimap-module--st6--9f81b"};